import { render, staticRenderFns } from "./BasSupplierModal.vue?vue&type=template&id=08141b39&scoped=true&"
import script from "./BasSupplierModal.vue?vue&type=script&lang=js&"
export * from "./BasSupplierModal.vue?vue&type=script&lang=js&"
import style0 from "./BasSupplierModal.vue?vue&type=style&index=0&id=08141b39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08141b39",
  null
  
)

export default component.exports